import * as ss from 'superstruct';

/**
 * Google Local Services Ads leads.
 *
 * No credential here — LSA reads go through the agency management account's
 * global OAuth token, so the only per-stream config is which Google Ads
 * customer to read.
 */
export const GoogleLsaLeadInputStreamSource = ss.type({
  name: ss.literal('google-lsa-lead'),
  /** 10-digit Google Ads customer ID.  Dashes are stripped before use. */
  customerId: ss.string(),
});

export type GoogleLsaLeadInputStreamSource = ss.Infer<
  typeof GoogleLsaLeadInputStreamSource
>;
